import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import {
  Layout,
  Button,
  // Icon,
  Menu,
  Avatar,
  Dropdown,
  // Breadcrumb
} from 'antd'
import {
  MenuFoldOutlined, MenuUnfoldOutlined, LogoutOutlined,
  LockOutlined,
} from '@ant-design/icons'
import history from 'utils/history'
import { Sidebar } from '../elements'

const { Header, Content } = Layout

const PrivateLayout = ({
  children, doLogout, collapse, handleCollapse,
  handleKeys, site, currentUser,
}) => (
  <div className="app main">
    <div id="yield" className="app-main-body">
      <Layout className="h-100">
        <Sidebar
          currentUser={currentUser}
          collapse={collapse}
          site={site}
          handleKeys={(param, isOpenSub) => handleKeys(param, isOpenSub)}
        />
        <Layout className="main-content h-100">
          <Header className="header d-flex align-items-center justify-content-between px-4" style={{ boxShadow: '-1px 1px 12px rgba(0, 34, 108, 0.15)' }}>
            <div className="d-flex align-items-center">
              {React.createElement(collapse ? MenuUnfoldOutlined : MenuFoldOutlined, {
                className: 'trigger',
                onClick: handleCollapse,
              })}

              <h6 className="mb-0 ml-3 d-none d-md-block" style={{ color: '#1B4DB3' }}>Admin Dashboard</h6>
            </div>
            <Dropdown
              overlay={(
                <Menu>
                  <Menu.Item key="0" onClick={doLogout}>
                    <Button type="link">
                      <LogoutOutlined />
                      {' '}
                      Keluar
                    </Button>
                  </Menu.Item>
                  {/* <Menu.Item key="change-password" onClick={() => history.push('/change-password')}>
                    <Button type="link">
                      <LockOutlined />
                      {' '}
                      Change Password
                    </Button>
                  </Menu.Item> */}
                </Menu>
                )}
              trigger={['click']}
            >
              <div className="d-flex align-self-center cursor-pointer align-items-center">
                <Avatar shape="circle" className="avatar-nav nav-text mr-2" size={34}>Admin</Avatar>
                <div className="f-flex flex-column d-none d-md-block">
                  <p style={{ lineHeight: '18px', fontSize: '14px' }} className="admin-name mb-0">{currentUser && currentUser.name ? currentUser.name.split(' ').slice(0, -1) : 'Admin'}</p>
                  {/* <p style={{ lineHeight: '18px', fontSize: '14px' }} className="admin-name mb-0">{currentUser && currentUser.name ? currentUser.name.split(' ').slice(0, -1) : 'Admin'}</p>
                  <p style={{ lineHeight: '18px', fontSize: '14px' }} className="mb-0">{currentUser && currentUser.email ? currentUser.email : '-'}</p> */}
                </div>
              </div>
            </Dropdown>

          </Header>

          {window.location.pathname === '/dashboard'
            && (
            <div className="d-block d-md-none" style={{ paddingLeft: '24px' }}>
              <p className="mb-0" style={{ margin: '16px 0' }}>{moment().format('DD MMMM YYYY')}</p>
            </div>
            )
          }
          <div className="d-flex justify-content-between align-items-center py-3" style={{ padding: '0 24px 24px' }}>
            {window.location.pathname === '/dashboard'
              && (
              <React.Fragment>
                <h3 className="title-content mb-0">{site.titlePage || ''}</h3>
                <p className="mb-0" style={{ margin: '16px 0' }}>{moment().format('DD MMMM YYYY')}</p>
              </React.Fragment>
              )
            }
          </div>
          <Content
            className="site-layout-background"
            style={{
              margin: 0,
              padding: '0 24px 24px',
            }}
          >
            {children}
          </Content>
        </Layout>
      </Layout>
    </div>
  </div>
)

PrivateLayout.propTypes = {
  children: PropTypes.node,
  doLogout: PropTypes.func,
  handleKeys: PropTypes.func,
  site: PropTypes.object,
  currentUser: PropTypes.any,
  collapse: PropTypes.bool,
  handleCollapse: PropTypes.func,
}

export default PrivateLayout
